import * as React from 'react';
import { AppContext } from '../../Context/app-state';
import './Backstyle.css';

export default function BackGround() {
  const { settings, setSettings } = React.useContext(AppContext);
  const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const changeBg = (id: number) => {
    setSettings({ ...settings, background: id });
  };
  const backGround = numbers.map((number) => (
    <div
      onClick={() => {
        changeBg(number);
      }}
      style={{ backgroundImage: `url(./assets/bg/${number}.jpg)` }}
      className="context"
    />
  ));
  return <div className="App-tree__background">{backGround}</div>;
}
